import { ALLOWED_SHINGLE_UIDS, ALLOWED_LOCALES } from "./constants";
/**
 * There exists a ShingleAttribute (mdms), "print_sample_link", which could be applicable here
 * I'm opting for a hard-coded list here instead because
 * - We can only edit such an attribute by migration (we never built CRUD for those)
 * - Hard-coding here is more overt for devs
 * - We'd still need an audience method for the Index page, before any shingle is selected (locale check). 
 *     So some hard-coding workaround is necessary anyway. I figure it's ideal to just keep all that logic in one place.
 *
 * TODO: remove that ShingleAttribute - `print_sample_link` from the backend. This was its only use afaik.
 * */

export const shingleUidHasOrderSamples = (
  shingleUid,
  allowedShingleUids = ALLOWED_SHINGLE_UIDS
) => allowedShingleUids.includes(shingleUid);

export const localeCodeHasOrderSamples = (
  localeCode,
  allowedLocales = ALLOWED_LOCALES
) => allowedLocales.includes(localeCode);
